import React, { useState } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter, Field } from './Dialog';
import LabNamingFields from './LabNamingFields';
import { academicPrefix, namingFormValue, namingPayload, namingError, previewLabName } from '../utils/labNaming';

export default function LabNameDialog({ lab, onClose, onSave, pending = false, error }) {
  const [initial] = useState(() => namingFormValue(lab));
  const [value, setValue] = useState(initial);
  const [validation, setValidation] = useState('');
  const dirty = Object.keys(value).some(key => value[key] !== initial[key]);
  const close = pending ? undefined : onClose;
  const submit = event => {
    event.preventDefault();
    const message = namingError(value);
    setValidation(message);
    if (!message && !pending) onSave(namingPayload(value));
  };
  return (
    <Dialog size="md" onClose={close} labelledBy="edit-lab-name-title" isDirty={dirty}>
      <DialogHeader id="edit-lab-name-title" title="Edit lab name" onClose={close} />
      <form className="dlg-form" onSubmit={submit}>
        <DialogBody>
          {(validation || error) && <div role="alert" className="dlg-alert">{validation || error}</div>}
          <Field label="Academic prefix" hint="Generated from the term, course and section.">
            <code style={{ overflowWrap: 'anywhere' }}>{academicPrefix(lab)}-</code>
          </Field>
          <LabNamingFields value={value} onChange={next => { setValue(next); setValidation(''); }} idPrefix="edit-lab" disabled={pending} />
          <Field label="Full name preview">
            <output aria-live="polite" style={{ display: 'block', overflowWrap: 'anywhere', color: 'var(--accent-primary)', fontFamily: 'var(--font-mono)' }}>
              {previewLabName(lab, value)}
            </output>
          </Field>
        </DialogBody>
        <DialogFooter>
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={pending}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={pending}>{pending ? 'Saving…' : 'Save name'}</button>
        </DialogFooter>
      </form>
    </Dialog>
  );
}
